import './Heading.scss';

export { default } from './Heading';
